<template>
    <div class="widget-component">
        <v-container
            fluid
            id="widget-my-profile-frame"
            class="widget-my-profile"
        >
            <v-container>
                <main-menu
                    v-if="normalizedOptions.menu.show"
                    :root-url="rootUrl"
                    :loginDialog="loginDialog"
                    :accessToken="accessToken"
                    :show-login-if-logged-out="true"
                    @loggedIn="handleLoginEmit"
                    :show-elements="normalizedOptions.menu.show"
                    @showLoginDialog="handleLoginDialogEmit"
                >
                </main-menu>
                <v-row v-if="normalizedOptions.title.show">
                    <v-col cols="12">
                        <h1 class="mb-4">
                            {{ normalizedOptions.title.text }}
                        </h1>
                    </v-col>
                </v-row>
                <v-form ref="form" v-model="formValid" v-if="loggedInProfile">
                    <v-row v-if="initializing">
                        <v-col cols="12" lg="6" xl="6">
                            <v-col cols="12">
                                <h2 class="mt-10 mb-4">Personal data</h2>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                            </v-col>
                        </v-col>
                        <v-col cols="12" lg="6" xl="6">
                            <v-col cols="12">
                                <h2 class="mt-10 mb-4">Living situation</h2>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                            </v-col>
                        </v-col>
                    </v-row>
                    <v-row v-if="initializing">
                        <v-col cols="12" lg="6" xl="6">
                            <v-col cols="12">
                                <h2 class="mt-10 mb-4">Work situation</h2>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                            </v-col>
                        </v-col>
                        <v-col cols="12" lg="6" xl="6">
                            <v-col cols="12">
                                <h2 class="mt-10 mb-4">
                                    Additional information
                                </h2>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>

                                <h2 class="mt-10 mb-2">
                                    Privacy policy and notifications
                                </h2>

                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="list-item-two-line"
                                ></v-skeleton-loader>
                            </v-col>
                        </v-col>
                    </v-row>
                    <v-row v-if="!initializing">
                        <v-col cols="12" lg="6" xl="6">
                            <v-col cols="12">
                                <h2 class="mt-10 mb-4">Personal data</h2>

                                <v-select
                                    v-model="formFields.title"
                                    :items="titleChoices"
                                    label="Title"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.title"
                                    :error="getError('title')"
                                    :error-messages="getErrorMessages('title')"
                                    @input="removeErrorMessage('title')"
                                ></v-select>

                                <v-text-field
                                    v-model="formFields.firstName"
                                    label="First name *"
                                    outlined
                                    required
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.firstName"
                                    :error="getError('firstName')"
                                    :error-messages="
                                        getErrorMessages('firstName')
                                    "
                                    @input="removeErrorMessage('firstName')"
                                ></v-text-field>

                                <v-text-field
                                    v-model="formFields.lastName"
                                    label="Last name *"
                                    outlined
                                    required
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.lastName"
                                    :error="getError('lastName')"
                                    :error-messages="
                                        getErrorMessages('lastName')
                                    "
                                    @input="removeErrorMessage('lastName')"
                                ></v-text-field>

                                <v-menu
                                    ref="menu"
                                    v-model="showDatePicker"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dateOfBirthFormatted"
                                            label="Date of birth"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            hide-details="auto"
                                            class="rounded-0 mb-4"
                                            :rules="rules.dateOfBirth"
                                            :error="getError('dateOfBirth')"
                                            :error-messages="
                                                getErrorMessages('dateOfBirth')
                                            "
                                            @input="
                                                removeErrorMessage(
                                                    'dateOfBirth'
                                                )
                                            "
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        ref="picker"
                                        v-model="formFields.dateOfBirth"
                                        :max="
                                            new Date()
                                                .toISOString()
                                                .substr(0, 10)
                                        "
                                        min="1900-01-01"
                                        @change="saveDobField"
                                    ></v-date-picker>
                                </v-menu>

                                <v-text-field
                                    v-model="formFields.phone"
                                    label="Phone number *"
                                    outlined
                                    required
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.phone"
                                    :error="getError('phone')"
                                    :error-messages="getErrorMessages('phone')"
                                    @input="removeErrorMessage('phone')"
                                ></v-text-field>

                                <v-text-field
                                    v-model="formFields.email"
                                    label="E-mail"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-col>
                        <v-col cols="12" lg="6" xl="6">
                            <v-col cols="12">
                                <h2 class="mt-10 mb-4">Living situation</h2>

                                <v-select
                                    v-model="formFields.livingCircumstance"
                                    :items="livingCircumstanceChoices"
                                    item-text="name"
                                    item-value="id"
                                    label="Current living situation"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.livingCircumstance"
                                    return-object
                                    :error="getError('livingCircumstance')"
                                    :error-messages="
                                        getErrorMessages('livingCircumstance')
                                    "
                                    @input="
                                        removeErrorMessage('livingCircumstance')
                                    "
                                ></v-select>

                                <v-select
                                    v-model="formFields.homeOwnershipStatus"
                                    :items="homeOwnershipStatusChoices"
                                    item-text="name"
                                    item-value="id"
                                    label="Home ownership status"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.homeOwnershipStatus"
                                    :error="getError('homeOwnershipStatus')"
                                    :error-messages="
                                        getErrorMessages('homeOwnershipStatus')
                                    "
                                    @input="
                                        removeErrorMessage(
                                            'homeOwnershipStatus'
                                        )
                                    "
                                ></v-select>

                                <v-text-field
                                    v-model.number="formFields.dependants"
                                    type="number"
                                    label="Dependants"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.dependants"
                                    :error="getError('dependants')"
                                    :error-messages="
                                        getErrorMessages('dependants')
                                    "
                                    @input="removeErrorMessage('dependants')"
                                ></v-text-field>

                                <v-text-field
                                    v-model="formFields.homePostcode"
                                    label="Current postcode"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.homePostcode"
                                    :error="getError('homePostcode')"
                                    :error-messages="
                                        getErrorMessages('homePostcode')
                                    "
                                    @input="removeErrorMessage('homePostcode')"
                                >
                                    <template v-slot:append>
                                        <v-menu
                                            open-on-hover
                                            origin="center center"
                                            transition="scale-transition"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon
                                                        >mdi-help-box</v-icon
                                                    >
                                                </v-btn>
                                            </template>

                                            <v-card
                                                elevation="2"
                                                max-width="260"
                                            >
                                                <v-card-text>
                                                    Tell us the postcode for
                                                    where you live at the
                                                    moment.
                                                </v-card-text>
                                            </v-card>
                                        </v-menu>
                                    </template>
                                </v-text-field>

                                <v-text-field
                                    v-model.number="
                                        formFields.annualHouseholdIncome
                                    "
                                    type="number"
                                    label="Household income"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.annualHouseholdIncome"
                                    prefix="£"
                                    :error="getError('annualHouseholdIncome')"
                                    :error-messages="
                                        getErrorMessages(
                                            'annualHouseholdIncome'
                                        )
                                    "
                                    @input="
                                        removeErrorMessage(
                                            'annualHouseholdIncome'
                                        )
                                    "
                                >
                                    <template v-slot:append>
                                        <v-menu
                                            open-on-hover
                                            origin="center center"
                                            transition="scale-transition"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon
                                                        >mdi-help-box</v-icon
                                                    >
                                                </v-btn>
                                            </template>

                                            <v-card
                                                elevation="2"
                                                max-width="260"
                                            >
                                                <v-card-text>
                                                    Tell us the total income
                                                    before tax, of everyone who
                                                    will be buying the home.
                                                </v-card-text>
                                            </v-card>
                                        </v-menu>
                                    </template>
                                </v-text-field>

                                <v-text-field
                                    v-model.number="formFields.deposit"
                                    type="number"
                                    label="Deposit"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.deposit"
                                    prefix="£"
                                    :error="getError('deposit')"
                                    :error-messages="
                                        getErrorMessages('deposit')
                                    "
                                    @input="removeErrorMessage('deposit')"
                                >
                                    <template v-slot:append>
                                        <v-menu
                                            open-on-hover
                                            transition="scale-transition"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon
                                                        >mdi-help-box</v-icon
                                                    >
                                                </v-btn>
                                            </template>

                                            <v-card
                                                elevation="2"
                                                max-width="260"
                                            >
                                                <v-card-text>
                                                    Tell us the amount of
                                                    savings you are planning to
                                                    put toward your deposit
                                                </v-card-text>
                                            </v-card>
                                        </v-menu>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="6" xl="6">
                            <v-col cols="12">
                                <h2 class="mt-10 mb-4">Work situation</h2>

                                <v-select
                                    v-model="formFields.workingCircumstance"
                                    :items="workingCircumstanceChoices"
                                    item-text="name"
                                    item-value="id"
                                    label="Working circumstance"
                                    outlined
                                    return-object
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.workingCircumstance"
                                    :error="getError('workingCircumstance')"
                                    :error-messages="
                                        getErrorMessages('workingCircumstance')
                                    "
                                    @input="
                                        removeErrorMessage(
                                            'workingCircumstance'
                                        )
                                    "
                                ></v-select>

                                <v-text-field
                                    v-model="formFields.employerName"
                                    label="Employer name"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    v-if="
                                        formFields.workingCircumstance &&
                                        formFields.workingCircumstance.working
                                    "
                                    :rules="rules.employerName"
                                    :error="getError('employerName')"
                                    :error-messages="
                                        getErrorMessages('employerName')
                                    "
                                    @input="removeErrorMessage('employerName')"
                                ></v-text-field>

                                <v-text-field
                                    id="thisistheoccupationfield"
                                    v-model="formFields.occupation"
                                    label="Job Title"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    v-if="
                                        formFields.workingCircumstance &&
                                        formFields.workingCircumstance.working
                                    "
                                    :rules="rules.occupation"
                                    :error="getError('occupation')"
                                    :error-messages="
                                        getErrorMessages('occupation')
                                    "
                                    @input="removeErrorMessage('occupation')"
                                ></v-text-field>

                                <v-text-field
                                    v-model="formFields.workPostcode"
                                    label="Work postcode"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    v-if="
                                        formFields.workingCircumstance &&
                                        formFields.workingCircumstance.working
                                    "
                                    :rules="rules.workPostcode"
                                    :error="getError('workPostcode')"
                                    :error-messages="
                                        getErrorMessages('workPostcode')
                                    "
                                    @input="removeErrorMessage('workPostcode')"
                                >
                                    <template v-slot:append>
                                        <v-menu
                                            open-on-hover
                                            origin="center center"
                                            transition="scale-transition"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon
                                                        >mdi-help-box</v-icon
                                                    >
                                                </v-btn>
                                            </template>

                                            <v-card
                                                elevation="2"
                                                max-width="260"
                                            >
                                                <v-card-text>
                                                    Tell us the postcode of
                                                    where you normally go to
                                                    work.
                                                </v-card-text>
                                            </v-card>
                                        </v-menu>
                                    </template>
                                </v-text-field>

                                <v-select
                                    v-model="formFields.armedForcesMember"
                                    :items="armedForcesMemberChoices"
                                    label="Are you a member of the armed forces?"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.armedForcesMember"
                                    :error="getError('armedForcesMember')"
                                    :error-messages="
                                        getErrorMessages('armedForcesMember')
                                    "
                                    @input="
                                        removeErrorMessage('armedForcesMember')
                                    "
                                ></v-select>
                            </v-col>
                        </v-col>
                        <v-col cols="12" lg="6" xl="6">
                            <v-col cols="12">
                                <h2 class="mt-10 mb-4">
                                    Additional information
                                </h2>

                                <v-select
                                    v-model="formFields.eligibleCitizen"
                                    :items="eligibleCitizenChoices"
                                    label="Are you a British, EU/EEA citizen or have ILR?"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.eligibleCitizen"
                                    :error="getError('eligibleCitizen')"
                                    :error-messages="
                                        getErrorMessages('eligibleCitizen')
                                    "
                                    @input="
                                        removeErrorMessage('eligibleCitizen')
                                    "
                                ></v-select>

                                <v-select
                                    v-model="formFields.hasDisability"
                                    :items="hasDisabilityChoices"
                                    label="Do you have any known disability?"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.hasDisability"
                                    :error="getError('hasDisability')"
                                    :error-messages="
                                        getErrorMessages('hasDisability')
                                    "
                                    @input="removeErrorMessage('hasDisability')"
                                ></v-select>

                                <v-select
                                    v-model="formFields.bestTimeToContactYou"
                                    :items="bestTimeToContactChoices"
                                    item-text="name"
                                    item-value="id"
                                    label="Best time to contact"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.bestTimeToContactYou"
                                    :error="getError('bestTimeToContactYou')"
                                    :error-messages="
                                        getErrorMessages('bestTimeToContactYou')
                                    "
                                    @input="
                                        removeErrorMessage(
                                            'bestTimeToContactYou'
                                        )
                                    "
                                ></v-select>

                                <v-select
                                    v-model="formFields.buyingInterestPeriod"
                                    :items="buyingInterestPeriodChoices"
                                    item-text="name"
                                    item-value="id"
                                    label="Buying interest period"
                                    outlined
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :rules="rules.buyingInterestPeriod"
                                    :error="getError('buyingInterestPeriod')"
                                    :error-messages="
                                        getErrorMessages('buyingInterestPeriod')
                                    "
                                    @input="
                                        removeErrorMessage(
                                            'buyingInterestPeriod'
                                        )
                                    "
                                ></v-select>

                                <h2 class="mt-10 mb-2">
                                    Privacy policy and notifications
                                </h2>

                                <v-checkbox
                                    v-model="formFields.newsletterConsent"
                                    :label="
                                        normalizedOptions.fields
                                            .newsletterConsent.label
                                    "
                                    class="rounded-0 mb-4"
                                    hide-details="auto"
                                    :rules="rules.newsletterConsent"
                                    :error="getError('newsletterConsent')"
                                    :error-messages="
                                        getErrorMessages('newsletterConsent')
                                    "
                                ></v-checkbox>
                                <v-checkbox
                                    v-model="formFields.newsSurveysConsent"
                                    :label="
                                        normalizedOptions.fields
                                            .newsSurveysConsent.label
                                    "
                                    class="rounded-0 mb-4"
                                    :rules="rules.newsSurveysConsent"
                                    :error="getError('newsSurveysConsent')"
                                    :error-messages="
                                        getErrorMessages('newsSurveysConsent')
                                    "
                                ></v-checkbox>
                                <v-checkbox
                                    v-model="formFields.partnersOffersConsent"
                                    :label="
                                        normalizedOptions.fields
                                            .partnersOffersConsent.label
                                    "
                                    class="rounded-0 mb-4"
                                    hide-details="auto"
                                    :rules="rules.partnersOffersConsent"
                                    :error="getError('partnersOffersConsent')"
                                    :error-messages="
                                        getErrorMessages(
                                            'partnersOffersConsent'
                                        )
                                    "
                                ></v-checkbox>

                                <v-btn
                                    :disabled="!formValid"
                                    @click="validateForm"
                                    block
                                    color="primary"
                                    class="rounded-0 mb-4 mt-4"
                                >
                                    Update
                                </v-btn>
                            </v-col>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-container>

        <v-dialog
            v-model="showResponseDialog"
            persistent
            max-width="880px"
            attach="#widget-my-profile-frame"
        >
            <v-card>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col sm="12" md="12" lg="12" xl="12">
                                <div class="my-12 pt-16 text-center">
                                    <div
                                        v-if="
                                            normalizedOptions.responseDialog
                                                .icon.show
                                        "
                                        class="mx-auto mb-12"
                                    >
                                        <v-icon
                                            :size="
                                                normalizedOptions.responseDialog
                                                    .icon.size
                                            "
                                        >
                                            {{
                                                normalizedOptions.responseDialog
                                                    .icon.icon
                                            }}
                                        </v-icon>
                                    </div>

                                    <div
                                        class="mx-auto mb-6"
                                        v-if="
                                            normalizedOptions.responseDialog
                                                .header.show
                                        "
                                    >
                                        <h1
                                            v-if="
                                                normalizedOptions.responseDialog
                                                    .header.text
                                            "
                                        >
                                            {{
                                                normalizedOptions.responseDialog
                                                    .header.text
                                            }}
                                        </h1>
                                    </div>

                                    <div
                                        class="mx-auto mb-6"
                                        v-if="
                                            normalizedOptions.responseDialog
                                                .body.show
                                        "
                                        v-html="
                                            normalizedOptions.responseDialog
                                                .body.text
                                        "
                                    ></div>

                                    <div class="mx-auto">
                                        <v-btn
                                            :color="
                                                normalizedOptions.responseDialog
                                                    .searchButton.color
                                            "
                                            :href="rootUrl + '/search'"
                                            v-if="
                                                normalizedOptions.responseDialog
                                                    .searchButton.show
                                            "
                                        >
                                            {{
                                                normalizedOptions.responseDialog
                                                    .searchButton.text
                                            }}
                                        </v-btn>
                                        <v-btn
                                            :color="
                                                normalizedOptions.responseDialog
                                                    .closeButton.color
                                            "
                                            @click="closeResponseDialog"
                                            v-if="
                                                normalizedOptions.responseDialog
                                                    .closeButton.show
                                            "
                                        >
                                            {{
                                                normalizedOptions.responseDialog
                                                    .closeButton.text
                                            }}
                                        </v-btn>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    defineComponent,
    ref,
    onMounted,
    computed,
    watch,
    nextTick,
} from "@vue/composition-api";
import { clone, cloneDeep, find, forEach, has, isNil, merge } from "lodash";
import MainMenu from "./partials/MainMenu";
import ProfileService from "../services/ProfileService";
import HelperServices from "../services/HelperServices";

export default defineComponent({
    name: "MyProfile",
    components: { MainMenu },
    props: {
        rootUrl: {
            type: String,
            required: true,
        },
        accessToken: {
            type: String,
        },
        settings: {
            type: Object,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        showMenu: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, context) {
        const initializing = ref(false);
        const loading = ref(false);
        const token = ref(null);
        const form = ref(null);
        const formValid = ref(false);
        const loginDialog = ref(false);
        const showLoginDialogCloseButton = ref(true);
        const showDatePicker = ref(false);
        const picker = ref(null);
        const menu = ref(null);
        const working = ref(true);
        const validationErrors = ref([]);
        const showResponseDialog = ref(false);
        const loggedIn = ref(false);
        const loggedInProfile = ref(null);
        const livingCircumstanceChoices = ref([]);
        const workingCircumstanceChoices = ref([]);
        const buyingInterestPeriodChoices = ref([]);
        const bestTimeToContactChoices = ref([]);

        const formFields = ref({
            title: "",
            firstName: "",
            lastName: "",
            dateOfBirth: "",
            phone: "",
            email: "",
            livingCircumstance: {
                owner: false,
            },
            homeOwnershipStatus: "",
            dependants: 0,
            homePostcode: "",
            annualHouseholdIncome: null,
            deposit: null,
            workingCircumstance: "",
            occupation: "",
            employerName: "",
            workPostcode: "",
            armedForcesMember: 0,
            eligibleCitizen: 0,
            hasDisability: 0,
            bestTimeToContactYou: "",
            buyingInterestPeriod: "",
            newsletterConsent: false,
            newsSurveysConsent: false,
            partnersOffersConsent: false,
        });
        const titleChoices = ref([
            { text: "Mr", value: "mr" },
            { text: "Mrs", value: "mrs" },
            { text: "Miss", value: "miss" },
            { text: "Ms", value: "ms" },
            { text: "Mx", value: "mx" },
            { text: "Dr", value: "dr" },
            { text: "Sir", value: "sir" },
            { text: "Other", value: "other" },
        ]);
        const armedForcesMemberChoices = ref([
            { text: "Yes", value: 1 },
            { text: "No", value: 0 },
        ]);
        const eligibleCitizenChoices = ref([
            { text: "Yes", value: 1 },
            { text: "No", value: 0 },
        ]);
        const hasDisabilityChoices = ref([
            { text: "Yes", value: 1 },
            { text: "No", value: 0 },
        ]);
        const homeOwnershipStatusChoices = ref([
            {
                name: "I'm a first time buyer",
                id: 1,
                owner: false,
                disabled: false,
            },
            {
                name: "I do not own any property at the moment",
                id: 2,
                owner: false,
                disabled: false,
            },
            {
                name: "I own a property but it's currently in a selling process",
                id: 3,
                owner: true,
                disabled: false,
            },
            {
                name: "I own one or more properties",
                id: 4,
                owner: true,
                disabled: false,
            },
        ]);

        const rules = ref({
            title: [
                //v => !!v || 'Title is required',
            ],
            firstName: [(v) => !!v || "First name is required"],
            lastName: [(v) => !!v || "Last name is required"],
            dateOfBirth: [
                //v => !!v || 'Date of birth is required',
            ],
            phone: [(v) => !!v || "Phone number is required"],
            email: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+/.test(v) || "E-mail must be valid",
            ],
            livingCircumstance: [
                //v => !!v || 'Required',
            ],
            homeOwnershipStatus: [
                //v => !!v || 'Required',
            ],
            dependants: [
                //v => v >= 0 || 'Value must be 0 or greater then 0',
            ],
            homePostcode: [
                //v => !!v || 'Home postcode is required',
            ],
            annualHouseholdIncome: [
                //v => v >= 0 || 'Value must be 0 or greater then 0',
            ],
            deposit: [
                //v => v >= 0 || 'Value must be 0 or greater then 0',
            ],
            workingCircumstance: [
                //v => !!v || 'Required',
            ],
            occupation: [],
            employerName: [],
            workPostcode: [],
            armedForcesMember: [],
            eligibleCitizen: [],
            hasDisability: [],
            bestTimeToContactYou: [
                //v => !!v || 'Required',
            ],
            buyingInterestPeriod: [
                //v => !!v || 'Required',
            ],
            newsletterConsent: [],
            newsSurveysConsent: [],
            partnersOffersConsent: [],
        });

        const currencyFormatter = new Intl.NumberFormat("gb-GB", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        const defaultSettings = ref({
            enabled: true,
            title: {
                show: true,
                text: "My Profile",
            },
            menu: {
                show: false,
            },
            fields: {
                newsletterConsent: {
                    label: "I want to receive alerts about other relevant properties",
                },
                newsSurveysConsent: {
                    label: "I want to receive information relating to relevant news and surveys",
                },
                partnersOffersConsent: {
                    label: "I want to receive information and offers from chosen partners",
                },
            },
            responseDialog: {
                icon: {
                    show: true,
                    size: 112,
                    icon: "mdi-text-box-check-outline",
                },
                header: {
                    show: true,
                    text: "Your profile has been updated",
                },
                body: {
                    show: true,
                    text: "<p></p>",
                },
                searchButton: {
                    show: true,
                    color: "primary",
                    text: "Search",
                },
                closeButton: {
                    show: true,
                    color: "primary",
                    text: "Close",
                },
            },
            events: {
                redirectIfNotLoggedIn: "/login",
            },
        });

        const normalizedOptions = computed(() => {
            return merge(defaultSettings.value, props.settings);
        });

        const dateOfBirthFormatted = computed(() => {
            return formatDate(formFields.value.dateOfBirth);
        });

        watch(showDatePicker, (currentValue) => {
            currentValue &&
                setTimeout(() => (picker.value.activePicker = "YEAR"));
        });

        watch(
            () => cloneDeep(formFields.value.livingCircumstance),
            (currentValue) => {
                forEach(homeOwnershipStatusChoices.value, function (value) {
                    if (value.owner === false && currentValue.owner === true) {
                        value.disabled = true;
                        formFields.value.homeOwnershipStatus = "";
                    } else {
                        value.disabled = false;
                    }
                });
            }
        );

        function saveDobField(date) {
            menu.value.save(date);
        }

        function validateForm() {
            let valid = form.value.validate();
            if (valid) {
                submitForm();
            } else {
                nextTick(() => {
                    const target = document.querySelector(
                        ".v-messages.error--text:first-of-type"
                    );
                    scrollToElement(target, 300, 72);
                });
            }
        }

        function buildPayload() {
            let payload = clone(formFields.value);
            console.log(payload);
            payload.livingCircumstance = payload.livingCircumstance.id;
            payload.workingCircumstance = payload.workingCircumstance.id;
            if (payload.bestTimeToContactYou) {
                payload.bestTimeToContactYou = [payload.bestTimeToContactYou];
            } else {
                delete payload.bestTimeToContactYou;
            }

            if (has(payload, "email")) {
                delete payload.email;
            }

            return payload;
        }

        function submitForm() {
            let payload = buildPayload();
            loading.value = true;
            validationErrors.value = [];
            ProfileService.updateProfileData(payload)
                .then(function (response) {
                    showResponseDialog.value = true;
                })
                .catch(function (error) {
                    if (error.response.status == 422) {
                        validationErrors.value = error.response.data;
                        //Scroll to error
                        nextTick(() => {
                            const target = document.querySelector(
                                ".v-messages.error--text:first-of-type"
                            );
                            scrollToElement(target, 300, 72);
                        });
                    }
                })
                .then(function () {
                    loading.value = false;
                });
        }

        function getError(fieldName) {
            return has(validationErrors.value.errors, fieldName);
        }

        function getErrorMessages(fieldName) {
            if (getError(fieldName)) {
                return validationErrors.value.errors[fieldName];
            }
            return [];
        }

        function scrollToElement(
            target,
            duration = 300,
            offset = 0,
            easing = "easeInOutCubic"
        ) {
            if (isNil(target)) {
                return;
            }
            let options = {
                duration: duration,
                offset: offset,
                easing: easing,
            };
            context.root.$vuetify.goTo(target, options);
        }

        function removeErrorMessage(fieldName) {
            if (has(validationErrors.value.errors, fieldName)) {
                delete validationErrors.value.errors[fieldName];
            }
        }

        function setFormFieldsFromProfile(profile) {
            if (profile.title) {
                formFields.value.title = profile.title;
            }
            if (profile.firstName) {
                formFields.value.firstName = profile.firstName;
            }
            if (profile.lastName) {
                formFields.value.lastName = profile.lastName;
            }
            if (profile.dateOfBirth) {
                formFields.value.dateOfBirth = profile.dateOfBirth;
            }
            if (profile.phone) {
                formFields.value.phone = profile.phone;
            }
            if (profile.email) {
                formFields.value.email = profile.email;
            }
            if (profile.homeOwnershipStatus) {
                formFields.value.homeOwnershipStatus =
                    profile.homeOwnershipStatus;
            }
            if (profile.dependants) {
                formFields.value.dependants = profile.dependants;
            }
            if (profile.homePostcode) {
                formFields.value.homePostcode = profile.homePostcode;
            }
            if (profile.annualHouseholdIncome) {
                formFields.value.annualHouseholdIncome =
                    profile.annualHouseholdIncome;
            }
            if (profile.deposit) {
                formFields.value.deposit = profile.deposit;
            }
            if (profile.deposit) {
                formFields.value.deposit = profile.deposit;
            }
            if (profile.occupation) {
                formFields.value.occupation = profile.occupation;
            }
            if (profile.employerName) {
                formFields.value.employerName = profile.employerName;
            }

            if (profile.workPostcode) {
                formFields.value.workPostcode = profile.workPostcode;
            }

            if (has(profile, "armedForcesMember")) {
                if (profile.armedForcesMember === true) {
                    formFields.value.armedForcesMember = 1;
                } else if (profile.armedForcesMember === false) {
                    formFields.value.armedForcesMember = 0;
                }
            }
            if (has(profile, "eligibleCitizen")) {
                if (profile.eligibleCitizen === true) {
                    formFields.value.eligibleCitizen = 1;
                } else if (profile.eligibleCitizen === false) {
                    formFields.value.eligibleCitizen = 0;
                }
            }
            if (has(profile, "hasDisability")) {
                if (profile.hasDisability === true) {
                    formFields.value.hasDisability = 1;
                } else if (profile.hasDisability === false) {
                    formFields.value.hasDisability = 0;
                }
            }
            if (has(profile, "newsletterConsent")) {
                formFields.value.newsletterConsent = profile.newsletterConsent;
            }
            if (has(profile, "newsSurveysConsent")) {
                formFields.value.newsSurveysConsent =
                    profile.newsSurveysConsent;
            }
            if (has(profile, "partnersOffersConsent")) {
                formFields.value.partnersOffersConsent =
                    profile.partnersOffersConsent;
            }

            // Living circumstance
            if (profile.livingCircumstance) {
                formFields.value.livingCircumstance =
                    profile.livingCircumstance;
                if (has(profile, "livingCircumstance.id")) {
                    let choice = find(
                        livingCircumstanceChoices.value,
                        function (o) {
                            return o.id == profile.livingCircumstance.id;
                        }
                    );
                    if (choice) {
                        formFields.value.livingCircumstance.owner =
                            choice.owner;
                    }
                }
            }

            // Working circumstance
            if (profile.workingCircumstance) {
                formFields.value.workingCircumstance =
                    profile.workingCircumstance;
                if (has(profile, "workingCircumstance.id")) {
                    let choice = find(
                        workingCircumstanceChoices.value,
                        function (o) {
                            return o.id == profile.workingCircumstance.id;
                        }
                    );
                    if (choice) {
                        formFields.value.workingCircumstance.working =
                            choice.working;
                    }
                }
            }

            // bestTimeToContactYou
            if (profile.bestTimeToContactYou) {
                if (has(profile, "bestTimeToContactYou[0].id")) {
                    formFields.value.bestTimeToContactYou =
                        profile.bestTimeToContactYou[0].id;
                }
            }

            // buyingInterestPeriod
            if (profile.buyingInterestPeriod) {
                if (has(profile, "buyingInterestPeriod.id")) {
                    formFields.value.buyingInterestPeriod =
                        profile.buyingInterestPeriod.id;
                }
            }
        }

        function closeResponseDialog() {
            showResponseDialog.value = false;
        }

        function formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        }

        // Main Menu emit functions
        function handleLoginEmit(data) {
            initializing.value = true;
            if (data.loggedInProfile) {
                loggedInProfile.value = data.loggedInProfile;
            }
            if (data.accessToken) {
                token.value = data.accessToken;
            }
            setFormFieldsFromProfile(data.loggedInProfile);
            initializing.value = false;
        }

        function handleLoginDialogEmit(val) {
            loginDialog.value = val;
        }

        // End Main Menu emit functions

        function redirectToLogin() {
            if (has(normalizedOptions.value, "events.redirectIfNotLoggedIn")) {
                window.location.href =
                    normalizedOptions.value.events.redirectIfNotLoggedIn;
            }
        }

        function init() {
            initializing.value = true;
            Promise.all([
                HelperServices.getLivingCircumstances(),
                HelperServices.getWorkingCircumstances(),
                HelperServices.getBuyingInterestPeriods(),
                HelperServices.getBestTimeToContact(),
            ]).then((responses) => {
                if (has(responses, "0.data.data")) {
                    livingCircumstanceChoices.value = responses[0].data.data;
                }
                if (has(responses, "1.data.data")) {
                    workingCircumstanceChoices.value = responses[1].data.data;
                }
                if (has(responses, "2.data.data")) {
                    buyingInterestPeriodChoices.value = responses[2].data.data;
                }
                if (has(responses, "3.data.data")) {
                    bestTimeToContactChoices.value = responses[3].data.data;
                }

                ProfileService.getProfile()
                    .then((response) => {
                        loggedIn.value = true;
                        loggedInProfile.value = response;
                        setFormFieldsFromProfile(response);
                        initializing.value = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        loggedIn.value = false;
                        redirectToLogin();
                    });
            });
        }

        onMounted(() => {
            init();
        });

        return {
            // Variables
            initializing,
            loading,
            formValid,
            form,
            currencyFormatter,
            formFields,
            titleChoices,
            armedForcesMemberChoices,
            eligibleCitizenChoices,
            hasDisabilityChoices,
            showDatePicker,
            picker,
            menu,
            livingCircumstanceChoices,
            workingCircumstanceChoices,
            buyingInterestPeriodChoices,
            bestTimeToContactChoices,
            working,
            rules,
            homeOwnershipStatusChoices,
            validationErrors,
            loginDialog,
            showResponseDialog,
            loggedInProfile,
            showLoginDialogCloseButton,
            dateOfBirthFormatted,
            normalizedOptions,
            // Functions
            saveDobField,
            validateForm,
            submitForm,
            getError,
            getErrorMessages,
            removeErrorMessage,
            closeResponseDialog,
            handleLoginEmit,
            handleLoginDialogEmit,
        };
    },
});
</script>
